import { contentfulImageLoader } from "@utils/imageLoader";
import React, { FC } from "react";

import AnchorLink from "@/components/ui/AnchorLink/AnchorLink";
import Image from "@/components/ui/Image/Image";
import { AutoScrollTile } from "@/types";

interface AutoScrollTileProps {
  item: AutoScrollTile;
}

const TileScroll: FC<AutoScrollTileProps> = ({ item }) => {
  return (
    <div className="relative overflow-hidden aspect-16-9 rounded-md">
      <img
        className="w-full aspect-16-9 object-cover"
        src={contentfulImageLoader({ src: item.image.url, width: 390, quality: 80 })}
        srcSet={[390, 780].map((w) => `${contentfulImageLoader({ src: item.image.url, width: w, quality: 80 })} ${w}w`).join(", ")}
        sizes="390px"
        alt={item.image.title}
        loading="lazy"
        decoding="async"
      />
      <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-5"></div>
      <Image
        className="absolute top-0 left-1/2 -translate-x-1/2 pt-m w-[152px] [h-97px]"
        src={item.logo.url}
        alt={item.logo.title || ""}
        width={152}
        height={97}
      />
      <div className="absolute flex flex-col items-center gap-xs pb-m left-2/4 -translate-x-1/2 bottom-0">
        <h3 className="font-primary font-medium text-m tracking-[0.1em] text-white uppercase whitespace-nowrap">{item.title}</h3>
        <p className="text-white font-secondary font-secondary-light text-s ">{item.location}</p>
      </div>

      {item.cta && (
        <AnchorLink href={item.cta.link.url} className="absolute top-0 left-0 w-full h-full">
          <span className="sr-only">{item.cta.label}</span>
        </AnchorLink>
      )}
    </div>
  );
};
export default TileScroll;
